import { useQuery } from '@tanstack/react-query';
import {
  productPaymentConfigService,
  type ProductPaymentConfig,
} from '../../../services/product-payment-config';

/**
 * Config de cobrança do produto.
 *
 * Fica em `policies` mas é consumida também pelo wizard de proposta: é a mesma
 * pergunta ("este produto cobra pela Finance.API?") e duplicar o hook por
 * feature só criaria duas chaves de cache para o mesmo dado.
 */
export function useProductPaymentConfig(productCode: string | undefined) {
  return useQuery<ProductPaymentConfig | null, Error>({
    queryKey: ['product-payment-config', productCode],
    queryFn: async () => {
      if (!productCode) return null;
      const result = await productPaymentConfigService.getPaymentConfig(productCode);
      if (!result.success || !result.data) return null;
      return result.data;
    },
    enabled: !!productCode,
    // Configuração muda por operação manual no DynamoDB, não por ação do
    // usuário — 5 min é folgado e evita uma chamada por navegação.
    staleTime: 5 * 60 * 1000,
  });
}
